import { render, staticRenderFns } from "./ArticlesListView.vue?vue&type=template&id=545983bd&scoped=true&"
import script from "./ArticlesListView.vue?vue&type=script&lang=js&"
export * from "./ArticlesListView.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesListView.vue?vue&type=style&index=0&id=545983bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545983bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VAlert,VContainer,VPagination})
